import React from 'react';
import { Play, RefreshCw, Save, ChevronLeft, ChevronRight } from 'lucide-react';

const SimulationControls = ({ 
  onRestart, 
  onSaveProgress, 
  onNextScenario,
  onPreviousScenario,
  isSimulationActive,
  onStartSimulation,
  canGoNext,
  canGoPrevious
}) => {
  return (
    <div className="flex justify-between items-center p-4 bg-white rounded-lg shadow-sm">
      {/* <div>
        <button
          onClick={onPreviousScenario}
          disabled={!canGoPrevious}
          className={`mr-2 px-4 py-2 flex items-center rounded-md text-sm font-medium ${
            canGoPrevious 
              ? 'bg-gray-100 hover:bg-gray-200 text-gray-700' 
              : 'bg-gray-50 text-gray-400 cursor-not-allowed'
          }`}
        >
          <ChevronLeft size={16} className="mr-1" />
          Previous
        </button>
        
        <button
          onClick={onNextScenario}
          disabled={!canGoNext}
          className={`px-4 py-2 flex items-center rounded-md text-sm font-medium ${
            canGoNext 
              ? 'bg-gray-100 hover:bg-gray-200 text-gray-700' 
              : 'bg-gray-50 text-gray-400 cursor-not-allowed'
          }`}
        >
          Next
          <ChevronRight size={16} className="ml-1" />
        </button>
      </div> */}
      
      <div>
        {!isSimulationActive ? (
          <button
            onClick={onStartSimulation}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium flex items-center"
          >
            <Play size={16} className="mr-1" />
            Start Simulation
          </button>
        ) : (
          <>
            <button
              onClick={onRestart}
              className="mr-2 px-4 py-2 bg-amber-100 hover:bg-amber-200 text-amber-700 rounded-md text-sm font-medium flex items-center"
            >
              <RefreshCw size={16} className="mr-1" />
              Restart
            </button>
{/*             
            <button
              onClick={onSaveProgress}
              className="px-4 py-2 bg-green-100 hover:bg-green-200 text-green-700 rounded-md text-sm font-medium flex items-center"
            >
              <Save size={16} className="mr-1" />
              Save Progress
            </button> */}
          </>
        )}
      </div>
    </div>
  );
};

export default SimulationControls;